module.exports = __webpack_public_path__ + "static/media/Baayen_taipe_climate_1129.25c28508.pdf";